import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import assets from 'modules/assets'

class ArchiveLocationImage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      country: props.country,
      year: props.year
    }
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      country: nextProps.country,
      year: nextProps.year
    })
  }
  getImageSrc() {
    if (this.state.year == 2016) return assets('archive/photos/location/2016_' + this.state.country + '.jpg')
    if (this.state.year == 2017) return assets('images/locations/' + this.state.country + '.jpg')
  }
  render() {
    let src = this.getImageSrc()
    return (
      <div>
        <img src={src} />
      </div>
    )
  }
}
ArchiveLocationImage.contextTypes = {
}
ArchiveLocationImage.propTypes = {
}
function mapStateToProps(state, ownProps) {
  return {
  }
}

export default connect(mapStateToProps)(ArchiveLocationImage)



// WEBPACK FOOTER //
// ./src/components/Archive/ArchiveLocationImage.js